  <template >
   <div class="formPosition">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span> Filtrar informações de</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex" cols="12" sm="6">
        <v-select
        v-model="select1"
          :items="items1"
          label="Selecione"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="6">
        <v-select
         v-model="select2"
          :items="items2"
          filled
          label="Selecione"
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="6">
        <v-select
        v-model="anoAcademico"
          :items="items3"
          label="Ano Academico"
          outlined
        ></v-select>
      </v-col>

      <v-col class="d-flex" cols="12" sm="6">
         <v-combobox
                        v-model="editedItem.AnoLectivo"
                        :value="undefined"
                        item-value="idAnoLectivo"
                        item-text="descricao"
                        :items="anoLectivo"
                        chips
                        label="Ano Lectivo"
                      ></v-combobox>
      </v-col>
    </v-row>
  </v-container>
<v-btn class="mr-4" @click="submit">Filtrar</v-btn>
    </div>
      </v-col>
    </v-row>
  </v-container>
</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    select2: null,
    anoLectivo: [],
    anoAcademico: null,
    select1: null,
    items1: [
      'Aluno',
      'Professor',
      'Funcionario'
    ],
    items2: [
      'Instituicao',
      'Classe',
      'Turma',
      'Curso'
    ],
    items3: [
      '1',
      '2',
      '3',
      '4'
    ],
    editedItem: {
      AnoLectivo: null
    },
    defaultItem: {
      AnoLectivo: null
    }
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select

    this.initialize()
  },
  methods: {
    classe (idclasse) {
      this.$store.state.isloading = true
      this.$store.state.idclasse = idclasse
      this.$router.push('estudante')

      //  this.$store.dispatch('setidclasse', idclasse)
    },
    submit () {
      if (this.select1 === 'Aluno' && this.select2 === 'Instituicao') {
        this.$router.push('/painelEstatistica')
      } else
      if (this.select1 === 'Aluno' && this.select2 === 'Classe') {
        this.$router.push('/AlunoClasse')
      } else
      if (this.select1 === 'Aluno' && this.select2 === 'Turma') {
        this.$router.push('/AlunoTurma')
      } else
      if (this.select1 === 'Aluno' && this.select2 === 'Curso') {
        this.$router.push('/AlunoCurso')
      }
    }

  },

  async initialize () {
    try {
      this.anoLectivo = await axios
        .get('/listarAnoLectivo')
        .then(res => res.data)
      this.isLoading = false
    } catch (error) {
      this.isLoading = false
      console.log('errrrrrrrrrrrrrrrrrrro' + error)
      this.text = error
      this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
    }
  }
}

</script>
